// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7219ed2","667":"c048c2bf"}[chunkId] + ".chunk.js";
};